import {LoaderFunctionArgs} from 'react-router-dom';
import {getAppTracer} from '../../../app.tracer';
import {ISessionEndedStore, SessionEndedStore} from './session-ended.stores';

const trace = getAppTracer('session-ended.loader');

export async function sessionEndedRouteLoader(args: LoaderFunctionArgs): Promise<ISessionEndedStore> {
    trace.info('Starting');

    const store = new SessionEndedStore();

    trace.info('Completed successfully');
    return store;
}
